import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'

export interface PushKey {
  public_key: string | null
  enabled: boolean
}

export interface PushSubscriptionPayload {
  endpoint: string
  keys: { p256dh: string; auth: string }
}

export const pushApi = {
  fetchKey: () => apiClient.get<ApiResponse<PushKey>>('/me/push/key'),

  subscribe: (payload: PushSubscriptionPayload) =>
    apiClient.post('/me/push/subscriptions', payload),

  unsubscribe: (endpoint: string) =>
    apiClient.delete('/me/push/subscriptions', { data: { endpoint } }),
}
